import {
  assignUserRole,
  getAllUsers,
  getCurrentUser,
  getUserMetadata,
  removeUserRole,
} from '@services/userService';
import { userActionTypes } from './actionTypes/user';
import { failure, loading, totalItems } from './commonActions';
import { setLoggedIn } from './authActions';
import { UserEntityInterface, UserQueryInterface, UserMetadataResponseInterface } from '@types';
import { setNotification } from '@actions/appActions';
import { setSubmissionUser } from '@actions/submissionEnvironmentActions';
import { getAppConfig } from '@services/publicService';
import { setConfigVariables } from '@actions/appEnvironmentActions';

export const setCurrentUser = (user: UserEntityInterface) => {
  return {
    type: userActionTypes.SET_CURRENT_USER,
    payload: user,
  };
};

export const setUserMetadata = (metadata: UserMetadataResponseInterface) => {
  return {
    type: userActionTypes.SET_USER_METADATA,
    payload: metadata,
  };
};

export const setUsers = (users: UserEntityInterface[]) => {
  return {
    type: userActionTypes.SET_USERS,
    payload: users,
  };
};

export const makeAddUserRole = (userId: string, roleId: string) => {
  return async (dispatch, getState) => {
    try {
      await assignUserRole(userId, roleId);
      const store = getState();
      const filters = store.user.usersFilters;

      const updatedQuery = { ...filters, ...{ offset: 0, limit: 100000, withRoles: true } };
      dispatch(makeUsersWithRoles(updatedQuery));
    } catch (err) {
      dispatch(setNotification({ textKey: 'error', variant: 'error' }));
    }
  };
};

export const makeRemoveUserRole = (userId: string) => {
  return async (dispatch, getState) => {
    try {
      await removeUserRole(userId);
      const store = getState();
      const filters = store.user.usersFilters;

      const updatedQuery = { ...filters, ...{ offset: 0, limit: 10000, withRoles: true } };
      dispatch(makeUsersWithRoles(updatedQuery));
    } catch (err) {
      dispatch(setNotification({ textKey: 'error', variant: 'error' }));
    }
  };
};

export const makeCurrentUser = () => {
  return async (dispatch) => {
    try {
      dispatch(loading(true, 'app'));
      const user = await getCurrentUser();
      const metadata = await getUserMetadata();
      const appConfig = await getAppConfig();
      dispatch(setConfigVariables(appConfig));
      dispatch(setUserMetadata(metadata));
      dispatch(setCurrentUser(user));
      dispatch(setSubmissionUser(user));
      dispatch(setLoggedIn(true));
      dispatch(loading(false, 'app'));
    } catch (err) {
      dispatch(failure(true, 'current_user'));
      dispatch(loading(false, 'app'));
    }
  };
};

export const makeUsersWithRoles = (query?: Omit<UserQueryInterface, 'lang'>) => {
  const instanceName = 'users';
  return async (dispatch) => {
    try {
      const { items, total } = await getAllUsers(query);
      dispatch(setUsers(items));
      dispatch(totalItems(total, instanceName));
    } catch (err) {
      dispatch(setNotification({ textKey: 'error', variant: 'error' }));
    }
  };
};

export const setUserFiltersPartially = (query?: Partial<UserQueryInterface>) => {
  return (dispatch, getState) => {
    const store = getState();
    const filters = store.user.usersFilters;

    const updatedQuery = { ...filters, ...query };

    dispatch({
      type: userActionTypes.SET_USERS_FILTERS,
      payload: updatedQuery,
    });
  };
};
